/**
 * Flag "tour già visto", condiviso tra il trigger contestuale
 * (useContextualTourTrigger) e il runtime (useDriverTour).
 *
 * REGOLA: il flag va scritto SOLO quando il tour è stato effettivamente
 * mostrato e poi chiuso/completato (onDestroyed di driver.js), MAI prima del
 * lancio. Diversamente un tour che non parte (selettore assente su un account
 * nuovo con sezioni vuote) resterebbe marcato "visto" per sempre e non
 * verrebbe più ritentato.
 *
 * La chiave è versionata (`-v2-`): il bump azzera i flag "bruciati" dal vecchio
 * comportamento, così tutti gli utenti esistenti ritentano i tour una volta.
 */
const SEEN_KEY = (taskId: string) => `flusia-tour-seen-v2-${taskId}`;

export function isTourSeen(taskId: string): boolean {
  try {
    return localStorage.getItem(SEEN_KEY(taskId)) === '1';
  } catch {
    return false;
  }
}

export function markTourSeen(taskId: string): void {
  try {
    localStorage.setItem(SEEN_KEY(taskId), '1');
  } catch {
    // localStorage non disponibile (private mode) → no-op
  }
}
